import { MemoDetail } from 'src/app/modules/memos/model/memo.model';
import {
  ApprovalRequestList,
  MemoAction,
  NegotiateStatus,
  NextApprovalPopupState,
  PaymentData,
  PreviewData,
} from './approval-request.models';

export class ShowMemoDetail {
  static readonly type = '[Approval Request] ShowMemoDetail';
  constructor(
    public memoId: number,
    public viaLink?: boolean,
    public options?: {
      memo_type: string;
      otp?: string;
      ref?: string;
      onVerifyError?: (error: any) => void;
    },
  ) {}
}

export class SetBackgroundTask {
  static readonly type = '[Approval Request] Set Background Task';
  constructor(public taskId: string, public title?: string) {}
}

export class InitialMemoDetail {
  static readonly type = '[Approval Request] InitialMemoDetail';
  constructor(public detail: MemoDetail, public viaLink?: boolean) {}
}

export class ClearSelectMemo {
  static readonly type = '[Approval Request] ClearSelectMemo';
  constructor(public showingMenu?: boolean) {}
}

export class ToggleMenu {
  static readonly type = '[Approval Request] ToggleMenu';
  constructor() {}
}

export class ShowDecisionPopup {
  static readonly type = '[Approval Request] ShowDecisionPopup';
  constructor(
    public action?: MemoAction,
    public options?: { is_user: boolean },
  ) {}
}

export class SaveComment {
  static readonly type = '[Approval Request] SaveComment';
  constructor(public comments: string[]) {}
}

export class SaveOTP {
  static readonly type = '[Approval Request] SaveOTP';
  constructor(public otp: string) {}
}

export class SaveReason {
  static readonly type = '[Approval Request] SaveReason';
  constructor(
    public reason:
      | string
      | { negotiate_amount: number; reason: string },
  ) {}
}

export class SaveSignature {
  static readonly type = '[Approval Request] SaveSignature';
  constructor(public signature: File | null) {}
}

// Discards any draft signature left over from a previous signer on the same
// device/session, without the popup/decision side effects SaveSignature(null) carries.
export class ClearSignatureDraft {
  static readonly type = '[Approval Request] ClearSignatureDraft';
  constructor() {}
}

export class SaveConfirm {
  static readonly type = '[Approval Request] SaveConfirm';
  constructor() {}
}

export class SaveStamp {
  static readonly type = '[Approval Request] SaveStamp';
  constructor(
    public key: string,
    public file: File,
    public imageUrl: string | ArrayBuffer,
  ) {}
}

export class SaveLocation {
  static readonly type = '[Approval Request] SaveLocation';
  constructor(
    public location: { longitude: number; latitude: number },
  ) {}
}

export class CancelDecisionPopup {
  static readonly type = '[Approval Request] CancelDecisionPopup';
  constructor() {}
}

export class ClearState {
  static readonly type = '[Approval Request] ClearState';
  constructor() {}
}

export class Approve {
  static readonly type = '[Approval Request] Approve';
  constructor() {}
}

export class Reject {
  static readonly type = '[Approval Request] Reject';
  constructor() {}
}

export class Terminate {
  static readonly type = '[Approval Request] Terminate';
  constructor() {}
}

export class MultiApprove {
  static readonly type = '[Approval Request] MultiApprove';
  constructor() {}
}

export class MultiApproveForS11Document {
  static readonly type =
    '[Approval Request] MultiApproveForS11Document';
  constructor() {}
}

export class MultiReject {
  static readonly type = '[Approval Request] MultiReject';
  constructor() {}
}

export class MultiTerminate {
  static readonly type = '[Approval Request] MultiTerminate';
  constructor() {}
}

export class MultiTerminateS11Document {
  static readonly type =
    '[Approval Request] MultiTerminateS11Document';
  constructor() {}
}

export class Negotiate {
  static readonly type = '[Approval Request] Negotiate';
  constructor() {}
}

export class MultiNegotiate {
  static readonly type = '[Approval Request] MultiNegotiate';
  constructor() {}
}

export class NextApprovalPopup {
  static readonly type = '[ApprovalRequest] Next Approval Popup';
  constructor(
    public state: NextApprovalPopupState | null,
    public status?: NegotiateStatus,
  ) {}
}

export class ShowPreviewData {
  static readonly type = '[Approval Request] ShowPreviewData';
  constructor(public payload: PreviewData) {}
}

export class ClosePreviewData {
  static readonly type = '[Approval Request] ClosePreviewData';
  constructor() {}
}

export class UpdateMultiMemos {
  static readonly type = '[Approval Request] UpdateMultiMemos';
  constructor(public payload: ApprovalRequestList[]) {}
}

export class SetIsSelectAll {
  static readonly type = '[Approval Request] SetIsSelectAll';
  constructor(
    public isSelectAll: boolean,
    public memoType?: string | null,
  ) {}
}

export class EmptyContent {
  static readonly type = '[Approval Request] EmptyContent';
  constructor(public emptyContent?: boolean) {}
}

export class SetFromClickMemo {
  static readonly type = '[Approval Request] SetFromClickMemo';
  constructor(public fromClickMemo: boolean) {}
}

// Generic actions for saving form data and validation status
export class SaveFormDataAndStatus {
  static readonly type =
    '[Approval Request] Save Form Data And Status';

  constructor(
    public s11ContractData: PaymentData,
    public isValid: boolean,
  ) {}
}

export class UpdateMultiSelectedCount {
  static readonly type =
    '[Approval Request] UpdateMultiSelectedCount';
  constructor(public count: number) {}
}

// export class UpdateNegotiateAmountDisplay {
//   static readonly type =
//     '[Approval Request] Update Negotiate Amount Display';
//   constructor(public hasNegotiateAmount: boolean) {}
// }

export class EvidenceApproved {
  static readonly type = '[Approval Request] Evidence Approved';
  constructor(public memoId: number) {}
}

export class SetMultiApproveS11Done {
  static readonly type =
    '[Approval Request] Set Multi Approve S11 Done';
  constructor(public payload: boolean) {}
}

export class SaveListQueryParams {
  static readonly type = '[Approval Request] Save List Query Params';
  constructor(public params: Record<string, any>) {}
}
